module.exports = __webpack_public_path__ + "img/icon_map_1_5_yj_hg.3d7d24e1.png";